var _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1StreamOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 360,
    viewBox: "0 0 480 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 360,
    rx: 5,
    fill: "#D3D3D3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 115,
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1StreamOverlay);
export default __webpack_public_path__ + "static/media/1-stream-overlay.7b879293de37cff45258338b97879371.svg";
export { ForwardRef as ReactComponent };